// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"50a034f5","390":"b37f555f","416":"730ca856","538":"54a8a199","545":"45b31813","614":"16551ad8","676":"40f0547e","999":"78a7d764"}[chunkId] + ".chunk.js";
};